"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M6 22h12l-6-6zM23 3H1v16h6v-2H3V5h18v12h-4v2h6z"
}), 'AirplaySharp');